import { render, staticRenderFns } from "./lift.vue?vue&type=template&id=5892a8e0&scoped=true&"
import script from "./lift.vue?vue&type=script&lang=js&"
export * from "./lift.vue?vue&type=script&lang=js&"
import style0 from "./lift.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lift.vue?vue&type=style&index=1&id=5892a8e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892a8e0",
  null
  
)

export default component.exports